import http from "./HttpService";

var endpoint = `/reporting/analytics/partnership/`;

const headers = {};

const getPartnershipType = async () => {
    const response = await http.get(`${endpoint}type`);
      return response;
};

const getPartnershipStatus = async () => {
  const response = await http.get(`${endpoint}status`);
    return response;
};


const getPartnershipLocality = async () => {
  const response = await http.get(`${endpoint}locality`);
    return response;
};

const getPartnershipGrowth = async () => {
  const response = await http.get(`${endpoint}growth`);
    return response;
};




export default {
  getPartnershipType,
  getPartnershipStatus,
  getPartnershipLocality,
  getPartnershipGrowth
 };

 

// import http from "./HttpService";

// var endpoint = `${http.apiUrl}`;

// const headers = {};

// const getLocalPartnerData = async () => {
//   const response = await http.get(`${endpoint}localPartners`);

//   if (response) {
//     return response;
//   }
//   return undefined;
// };

// const getPrivatePartnerData = async () => {
//   const response = await http.get(`${endpoint}privatePartners`);

//   if (response) {
//     return response;
//   }
//   return undefined;
// };

// const getPartnerGrowthData = async () => {
//   const response = await http.get(`${endpoint}growthPartners`);

//   if (response) {
//     return response;
//   }
//   return undefined;
// };

// export default {
//     getLocalPartnerData,
//     getPrivatePartnerData,
//     getPartnerGrowthData,
//  };
